import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'app/components/ui/dropdown-menu';
import { CalendarDays } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/button';
import {
  generateICSFile,
  redirectToGoogleCalendar,
  redirectToOutlookCalendar,
} from './utils';

export interface AddToCalendarButtonContainerProps {
  eventData: {
    name: string;
    location: string;
    timeInterval: {
      startsAt: string;
      endsAt: string;
    };
    timezone: string;
  };
}

const AddToCalendarButtonContainer: React.FC<
  AddToCalendarButtonContainerProps
> = ({ eventData }) => {
  const { t } = useTranslation();

  const handleCalendarClick = (type: 'google' | 'ics' | 'outlook') => {
    switch (type) {
      case 'google':
        redirectToGoogleCalendar(eventData);
        break;
      case 'outlook':
        redirectToOutlookCalendar(eventData);
        break;
      case 'ics':
        generateICSFile(eventData);
        break;
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline">
          <CalendarDays size={20} />
          {t('orderConfirmationPage.addToCalendar')}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem onSelect={() => handleCalendarClick('google')}>
          Google
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => handleCalendarClick('outlook')}>
          Outlook
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => handleCalendarClick('ics')}>
          iOS
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => handleCalendarClick('ics')}>
          Android
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default AddToCalendarButtonContainer;
